export default "__VITE_PUBLIC_ASSET__beb2018a__"